import { ApiClient } from "Tools/api/client";
import { processResponse, processResultsResponse } from "Tools/api/helpers";

export const createDevice = async (data: any) => {
  return processResponse(await ApiClient.post("digital-equipment/devices/", data));
};

export const getDevices = async <T = DetailedDeviceInformation>(params = {} as any, subpath = null as strnull_t, subpathData?: any) =>
  processResultsResponse<T[]>(await ApiClient[subpathData ? 'post' : 'get'](`digital-equipment/devices/${subpath ? subpath + '/' : ''}`, subpathData || { params }));

export const getAuditLog = async (params = {} as any) =>
  processResultsResponse<any[]>(await ApiClient.get('digital-equipment/devices/audit_log/', { params }));

export const getValencoDevices = async <T = DetailedDeviceInformation>(params = {} as any, subpath = null as strnull_t, subpathData?: any) =>
  processResultsResponse<T[]>(await ApiClient[subpathData ? 'post' : 'get'](`digital-equipment/devices/${subpath ? subpath + '/' : ''}`, subpathData || { params }));

export const deleteDevice = async (id: number) => {
  return processResponse(await ApiClient.delete(`digital-equipment/devices/${id}/`));
};

export const getStorageLocations = async (params = {} as any) => {
  return processResultsResponse(await ApiClient.get("digital-equipment/storage-location/", { params }));
};

export const getAddDeviceRequests = async <T = EquipmentStockAddDeviceRequest>(params = {} as any, subpath = null as strnull_t, subpathData?: any) =>
  processResultsResponse<T[]>(await ApiClient[subpathData ? 'post' : 'get'](`digital-equipment/available-request/${subpath ? subpath + '/' : ''}`, subpathData || { params }));


export const updateAddDeviceRequest = async (id: any, data: any) => {
  return processResponse(await ApiClient.patch(`digital-equipment/available-request/${id}/`, data))
}

export const resubmitAddDeviceRequest = async (id: any, data: any) => {
  return processResponse(await ApiClient.patch(`digital-equipment/available-request/${id}/resubmit/`, data))
}

export const declineAddDeviceRequest = async (id: any, data: any) => {
  return processResponse(await ApiClient.patch(`digital-equipment/available-request/${id}/decline/`, data))
}

export const postAddDeviceRequest = async (data: any) => {
  return processResponse(await ApiClient.post("digital-equipment/available-request/", data));
};

export const acceptDeviceRequest = async (id: any, data: any) => processResponse(await ApiClient.patch(`digital-equipment/available-request/${id}/accept/`, data))


export const getUsageHistory = async (params = {} as any) => {
  return processResultsResponse<EquipmentUsageInformation[]>(await ApiClient.get("digital-equipment/usage-information/", { params }));
};

export const updateDevice = async (id: number, data: any) => processResponse(await ApiClient.patch(`digital-equipment/devices/${id}/`, data));

export const getDeviceRequests = async (params = {} as any, subpath?: string) => {
  return processResultsResponse<DeviceRequest[]>(await ApiClient.get(`digital-equipment/request/${subpath ? subpath + '/' : ''}`, { params }));
};

export const createDeviceRequest = async (data: any) => {
  return processResponse(await ApiClient.post("digital-equipment/request/", data));
};
export const updateDeviceRequest = async (id: number, data: any) => processResponse(await ApiClient.patch(`digital-equipment/request/${id}/`, data));

export const addDeviceStorageLocation = async (data: any) => {
  return processResponse(await ApiClient.post("digital-equipment/storage-location/", data));
};

/**Use for both DELETE and GET deleted devices */
export const deleteDeviceAction = async (id: any, params = {} as any) => processResultsResponse<DetailedDeviceInformation[]>(await ApiClient[id ? 'delete' : 'get'](`digital-equipment/devices/soft_deletion/${id ? '?id=' + id : ''}`, { params }))


export const getSensorCategories = async (params = {} as any) => {
  return processResultsResponse<EquipmentSensorCategory[]>(await ApiClient.get("digital-equipment/sensor-category/", { params }));
}

export const getDeviceTypes = async (params = {} as any) => {
  return processResultsResponse<EquipmentSensorType[]>(await ApiClient.get("digital-equipment/sensor-type/", { params }));
}

export const getManufacturers = async (params = {} as any) => {
  return processResultsResponse<EquipmentDeviceManufacturer[]>(await ApiClient.get("digital-equipment/device-manufacturer/", { params }));
}

export const getEquipmentSettingsData = async (params = {} as any) => {
  return processResultsResponse<any>(await ApiClient.get(""));
}

export const getDeviceModels = async (params = {} as any) => {
  return processResultsResponse<EquipmentDeviceModel[]>(await ApiClient.get("digital-equipment/device-model/", { params }));
}

export const getUsers = async (params = {} as any) => { return processResultsResponse(await ApiClient.get("index/users/", { params })); }


export const createOrUpdateSensorCategory = async (data: any, editingId = 0) => {
  let url = `digital-equipment/sensor-category/${editingId ? editingId + '/' : ''}`
  return processResponse(await ApiClient[editingId ? 'patch' : 'post'](url, data));
};

export const deleteSensorCategory = async (id: number) => {
  return processResponse(await ApiClient.delete(`digital-equipment/sensor-category/${id}/`));
};

export const getSensorCategoryImpactedDevices = async (id: number) => {
  return processResponse(await ApiClient.get(`digital-equipment/sensor-category/${id}/impacted_devices/`));
};

export const reassignSensorCategoryDevices = async (id: number, reassignments: any[]) => {
  return processResponse(await ApiClient.post(`digital-equipment/sensor-category/${id}/reassign_devices/`, { reassignments }));
};


export const createOrUpdateDeviceManufacturer = async (data: any, editingId = 0) => {
  let url = `digital-equipment/device-manufacturer/${editingId ? editingId + '/' : ''}`
  return processResponse(await ApiClient[editingId ? 'patch' : 'post'](url, data));
};

export const deleteDeviceManufacturer = async (id: number) => {
  return processResponse(await ApiClient.delete(`digital-equipment/device-manufacturer/${id}/`));
};


export const createOrUpdateDeviceType = async (data: any, editingId = 0) => {
  let url = `digital-equipment/sensor-type/${editingId ? editingId + '/' : ''}`
  return processResponse(await ApiClient[editingId ? 'patch' : 'post'](url, data));
};

export const deleteDeviceType = async (id: number) => {
  return processResponse(await ApiClient.delete(`digital-equipment/sensor-type/${id}/`));
};

export const getDeviceTypeImpactedDevices = async (id: number) => {
  return processResponse(await ApiClient.get(`digital-equipment/sensor-type/${id}/impacted_devices/`));
};

export const reassignDeviceTypeDevices = async (id: number, reassignments: any[]) => {
  return processResponse(await ApiClient.post(`digital-equipment/sensor-type/${id}/reassign_devices/`, { reassignments }));
};


export const createOrUpdateDeviceModel = async (data: any, editingId = 0) => {
  let url = `digital-equipment/device-model/${editingId ? editingId + '/' : ''}`
  return processResponse(await ApiClient[editingId ? 'patch' : 'post'](url, data));
};


export const deleteDeviceModel = async (id: number) => {
  return processResponse(await ApiClient.delete(`digital-equipment/device-model/${id}/`));
};


export const getOrCreateOrUpdateDeviceViewPreferences = async <T = ColumnVisibilityModel>(params: any, subpath: strund_t = undefined, data: any = null) => {
  return processResponse<T>(await ApiClient[data ? 'post' : 'get'](`digital-equipment/preferences-all_devices-view/${subpath ? subpath + '/' : ''}`, data || { params }));
}

export const createOrUpdateCountryDeviceViewPreferences = async <T = ColumnVisibilityModel>(id: any, subpath: strund_t = undefined, data: any = null) => {
  return processResponse<T>(await ApiClient['post'](`digital-equipment/preferences-admin-all_devices-view/${subpath ? subpath + '/' : ''}`, { id: id, data }));
}

export const getCountryDeviceViewPreferences = async <T = ColumnVisibilityModel>(params: any, subpath: strund_t = undefined) => {
  return processResultsResponse<T[]>(await ApiClient.get(`digital-equipment/preferences-admin-all_devices-view/${subpath ? subpath + '/' : ''}`, { params }));
}

export const getTrialLinkages = async <T = any>(params = {}) =>
  processResultsResponse<T[]>(await ApiClient.get('digital-equipment/trial-linkage/of_all_trials/', { params: { ...params, web_format: true } }));

export const getTrialLinkageCountries = async <T = any>() =>
  processResultsResponse<T[]>(await ApiClient.get('digital-equipment/trial-linkage/distinct_countries/'));



// ============================================================================
// REPORT MANAGER API FUNCTIONS
// ============================================================================


/**
 * Create a new custom report template (enhanced version)
 */
export const createCustomReportTemplate = async (data: {
  name: string;
  description?: string;
  template_type?: string;
  fields?: ReportField[];
  region?: string;
  country_id?: number;
}) => {
  return processResponse<ReportTemplate>(
    await ApiClient.post("digital-equipment/report-manager/create_custom_template/", data)
  );
};

/**
 * Get all available report templates (already exists but may need updates)
 */
export const getAvailableReportTemplates = async (params = {} as any) => {
  return processResultsResponse<ReportTemplate[]>(
    await ApiClient.get("digital-equipment/report-manager/get_available_reports/", { params })
  );
};

/**
 * Get template fields for a specific template (already exists)
 */
export const getTemplateFields = async (templateId: number) => {
  return processResponse<{template: ReportTemplate, fields: ReportField[]}>(
    await ApiClient.get(`digital-equipment/report-manager/${templateId}/get_template_fields/`)
  );
};

/**
 * Update field mappings for a template (already exists)
 */
export const updateTemplateFieldMappings = async (templateId: number, fieldsData?: ReportField[]) => {
  return processResponse(
    await ApiClient.put(`digital-equipment/report-manager/${templateId}/update_field_mappings/`, {
      fields: fieldsData
    })
  );
};

/**
 * Get available source fields (enhanced to include custom fields)
 */
export const getAvailableSourceFields = async () => {
  return processResultsResponse<SourceField[]>(
    await ApiClient.get("digital-equipment/report-manager/get_available_source_fields/")
  );
};

/**
 * Get available values for a source field (enhanced version)
 */
export const getFieldValues = async (sourceField: string) => {
  return processResponse<{field: string, label: string, values: {value: string, label: string}[]}>(
    await ApiClient.get(`digital-equipment/report-manager/get_field_values/`, { 
      params: { source_field: sourceField } 
    })
  );
};

/**
 * Get conditional output mapping for a template type and source field
 */
export const getConditionalOutputMapping = async (templateType: string, sourceField: string) => {
  return processResponse<{source_field: string, template_type: string, output_mapping: any}>(
    await ApiClient.get(`digital-equipment/report-manager/get_conditional_output_mapping/`, { 
      params: { template_type: templateType, source_field: sourceField } 
    })
  );
};

/**
 * Get available equipment types for ARM mapping
 */
export const getEquipmentTypes = async () => {
  return processResultsResponse<EquipmentType[]>(
    await ApiClient.get("digital-equipment/report-manager/get_equipment_types/")
  );
};

/**
 * Validate mapping rules configuration
 */
export const validateMappingRules = async (data: {
  mapping_rules: any;
  field_name: string;
}) => {
  return processResponse<{valid: boolean, errors?: string[]}>(
    await ApiClient.post("digital-equipment/report-manager/validate_mapping_rules/", data)
  );
};

/**
 * Add field to template
 */
export const addFieldToTemplate = async (templateId: number, fieldData: {
  field_name: string;
  source_field?: string;
  mapping_type?: string;
  mapping_rules?: any;
  default_value?: string;
  is_visible?: boolean;
  help_text?: string;
  validation_rules?: any;
}) => {
  return processResponse<{status: string, message: string, field: ReportField}>(
    await ApiClient.post(`digital-equipment/report-manager/${templateId}/add_field/`, fieldData)
  );
};

/**
 * Remove field from template
 */
export const removeFieldFromTemplate = async (templateId: number, fieldId: number) => {
  return processResponse(
    await ApiClient.delete(`digital-equipment/report-manager/${templateId}/remove_field/`, {
      data: { field_id: fieldId }
    })
  );
};

/**
 * Edit a specific field in a template
 */
export const editTemplateField = async (templateId: number, fieldData: {
  field_id: number;
  field_name?: string;
  source_field?: string;
  field_order?: number;
  is_visible?: boolean;
  default_value?: string;
  help_text?: string;
  mapping_type?: string;
  mapping_rules?: any;
  validation_rules?: any;
}) => {
  return processResponse<{status: string, message: string, field: ReportField}>(
    await ApiClient.put(`digital-equipment/report-manager/${templateId}/edit_field/`, fieldData)
  );
};

/**
 * Reorder fields in a template
 */
export const reorderTemplateFields = async (templateId: number, fieldOrders: {field_id: number, order: number}[]) => {
  return processResponse<{status: string, message: string}>(
    await ApiClient.put(`digital-equipment/report-manager/${templateId}/reorder_fields/`, {
      field_orders: fieldOrders
    })
  );
};

/**
 * Update template description
 */
export const updateTemplateDescription = async (templateId: number, description: string) => {
  return processResponse(
    await ApiClient.put(`digital-equipment/report-manager/${templateId}/update_description/`, {
      description
    })
  );
};

/**
 * Update template metadata (name, type, description, region, country)
 */
export const updateTemplate = async (templateId: number, templateData: {
  name?: string;
  description?: string;
  template_type?: string;
  region?: string;
  country_id?: number;
}) => {
  return processResponse(
    await ApiClient.put(`digital-equipment/report-manager/${templateId}/update_template/`, templateData)
  );
};

/**
 * Create template variant for specific region/country
 */
export const createTemplateVariant = async (data: {
  parent_template_id: number;
  name?: string;
  description?: string;
  country_id?: number;
  region?: string;
}) => {
  return processResponse<{template: ReportTemplate}>(
    await ApiClient.post("digital-equipment/report-manager/create_template_variant/", data)
  );
};

/**
 * Create a custom variant from any template (useful when getting system template restrictions)
 */
export const createCustomVariantFromTemplate = async (templateId: number, data: {
  name?: string;
  description?: string;
  country_id?: number;
  region?: string;
}) => {
  return processResponse<{template: ReportTemplate, message: string}>(
    await ApiClient.post(`digital-equipment/report-manager/${templateId}/create_custom_variant/`, data)
  );
};

/**
 * Create ARM standard template based on master mapping file structure
 */
export const createArmStandardTemplate = async (data: {
  name?: string;
  description?: string;
  country_id?: number;
  region?: string;
}) => {
  return processResponse<{template: ReportTemplate, message: string}>(
    await ApiClient.post("digital-equipment/report-manager/create_arm_standard_template/", data)
  );
};

/**
 * Get available template types dynamically
 */
export const getTemplateTypes = async () => {
  return processResultsResponse<{key: string, text: string}[]>(
    await ApiClient.get("digital-equipment/report-manager/get_template_types/")
  );
};

/**
 * Get countries for template variants
 */
export const getCountriesForTemplates = async () => {
  return processResultsResponse<{id: number, country_name: string, country_code: string}[]>(
    await ApiClient.get("digital-equipment/report-manager/get_countries/")
  );
};

/**
 * Get all available custom field definitions
 */
export const getCustomFieldDefinitions = async (params = {} as any) => {
  return processResultsResponse<CustomFieldDefinition[]>(
    await ApiClient.get("digital-equipment/report-manager/get_custom_field_definitions/", { params })
  );
};

/**
 * Create a new custom field definition
 */
export const createCustomFieldDefinition = async (data: {
  field_name: string;
  display_name: string;
  field_type: string;
  description?: string;
  category?: string;
  choice_options?: {value: string, label: string}[];
  validation_rules?: any;
}) => {
  return processResponse<CustomFieldDefinition>(
    await ApiClient.post("digital-equipment/report-manager/create_custom_field_definition/", data)
  );
};

/**
 * Delete a report template
 */
export const deleteReportTemplate = async (templateId: number) => {
  return processResponse(
    await ApiClient.delete(`digital-equipment/report-manager/${templateId}/delete_template/`)
  );
};

/**
 * Generate custom fields for devices based on template schema
 */
export const generateCustomFieldsForDevices = async (templateId: number, deviceIds: number[]) => {
  return processResponse(
    await ApiClient.post(`digital-equipment/report-manager/${templateId}/generate_custom_fields/`, {
      device_ids: deviceIds
    })
  );
};

/**
 * Migration helper: Move existing ARM fields to custom field system
 */
export const migrateArmFields = async () => {
  return processResponse(
    await ApiClient.post("digital-equipment/report-manager/migrate_arm_fields/")
  );
};

/**
 * Export report using template with conditional mapping logic applied
 */
export const exportTemplateBasedReport = async (templateId: number, filters?: {
  category?: string;
  manufacturer?: string;
  status?: string;
  country?: string;
}) => {
  const response = await ApiClient.post(`digital-equipment/report-manager/${templateId}/export_report/`, {
    filters: filters || {}
  }, {
    responseType: 'blob'
  });

  // Create blob and download file
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `report_${new Date().getTime()}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return { success: true };
};

/**
 * Export ARM Equipment Tab with 22 predefined columns
 */
export const exportArmEquipmentTab = async (data: {
  selected_sites?: string[];
  selected_equipment_categories?: string[];
  selected_equipment_ids?: number[];
}) => {
  const response = await ApiClient.post('digital-equipment/devices/export_arm_equipment_tab/', data, {
    responseType: 'blob'
  });

  // Create blob and download file
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `ARM_Equipment_Tab_${new Date().getTime()}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return { success: true };
};


// ============================================================================
// TYPE DEFINITIONS (Enhanced)
// ============================================================================

export interface ReportTemplate {
  id: number;
  name: string;
  template_type: string;
  description: string;
  is_system_template: boolean;
  created_at: string;
  field_count?: number;
  country?: string;
  region?: string;
  parent_template?: string;
  auto_generate_fields?: boolean;
  field_schema?: any;
  version?: string;
  is_active?: boolean;
}

export interface ReportField {
  id?: number;
  field_name: string;
  source_field: string;
  field_order: number;
  mapping_type: 'direct' | 'conditional';
  mapping_rules?: {
    condition_groups?: ConditionGroup[];
    default_output?: string;
    equipment_types?: string[];
    use_template_variables?: boolean;
    [key: string]: any;
  };
  is_editable: boolean;
  is_visible: boolean;
  default_value?: string;
  help_text?: string;
  validation_rules?: any;
}

export interface ConditionGroup {
  conditions: MappingCondition[];
  logicalOperator: 'AND' | 'OR';
}

export interface MappingCondition {
  operator: '==' | '!=' | '>' | '<' | '>=' | '<=' | 'contains' | 'not_contains' | 'empty' | 'not_empty';
  value: string;
  predicted_output?: string;
}

export interface SourceField {
  key: string;
  text: string;
  category: 'Core' | 'ARM' | 'Details' | 'Location' | 'Custom';
  data_type: 'text' | 'number' | 'date' | 'choice' | 'decimal' | 'boolean';
  is_custom_field?: boolean;
}

export interface EquipmentType {
  key: string;
  text: string;
}

export interface CustomFieldDefinition {
  id: number;
  field_name: string;
  display_name: string;
  field_type: 'text' | 'number' | 'decimal' | 'date' | 'boolean' | 'choice';
  description?: string;
  category: string;
  choice_options: {value: string, label: string}[];
  default_value?: string;
  validation_rules: any;
  template_types: string[];
  created_at: string;
  is_active: boolean;
}